var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#F4F4F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3467",
    x: -922,
    y: -836,
    width: 2522,
    height: 6392,
    rx: 16,
    fill: "#E6E5EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cart (No AC+ Coverage)",
    clipPath: "url(#clip0_12034_32118)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 414,
    height: 973,
    transform: "translate(-349 -360)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 6034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 7554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cart item instalment"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cart item"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -324.5,
    y: -139.5,
    width: 365,
    height: 188,
    rx: 7.5,
    stroke: "#B9BFC6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 7556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cart add-on V2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 7547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add/Remove"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add +"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: -7,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F2F4F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92886 8C1.37658 8 0.928862 8.44772 0.928862 9C0.928862 9.55228 1.37658 10 1.92886 10L7.99993 10L7.99993 16.071C7.99993 16.6233 8.44764 17.071 8.99993 17.071C9.55221 17.071 9.99993 16.6233 9.99993 16.071L9.99993 10H16.071C16.6233 10 17.071 9.55228 17.071 9C17.071 8.44772 16.6233 8 16.071 8H9.99993L9.99993 1.92893C9.99993 1.37665 9.55221 0.928932 8.99993 0.928932C8.44765 0.928932 7.99993 1.37665 7.99993 1.92893L7.99993 8L1.92886 8Z",
    fill: "#232A2D"
  })))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12034_32118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 414,
    height: 973,
    fill: "white",
    transform: "translate(-349 -360)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.c2d1d53637fb1adde6945836d55bfa8f.svg";
export { ForwardRef as ReactComponent };